import React from 'react'
import { Box, ListItem, ListItemIcon, ListItemText, Skeleton, Typography, useMediaQuery, useTheme } from '@mui/material'
import Grid from '@mui/material/Grid'
import LateFeeStatItem from 'components/pricing/LateFees/LateFeesListing/LateFeeStatItem'

const LateFeesAccordionItemSkeleton = () => {
  const theme = useTheme()
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const isTablet = useMediaQuery(theme.breakpoints.only('md'))
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const isXs = useMediaQuery(theme.breakpoints.down('sm'))
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <ListItem divider>
      <ListItemIcon
        sx={{
          minWidth: 0,
        }}
      >
        <Skeleton variant="circular" width={24} height={24} />
      </ListItemIcon>
      <Box height="100%" width="100%">
        <Grid container alignItems="center" justifyContent="center" flexWrap="nowrap">
          <Grid
            size={{
              xs: 'grow',
              sm: 'grow',
              md: 'grow',
              lg: 'grow',
            }}
          >
            <ListItem disableGutters>
              <ListItemText
                disableTypography
                primary={
                  <Skeleton>
                    <Typography variant="h4" color="textPrimary" fontWeight={600} noWrap>
                      <Box height="1.2rem" width={250} />
                    </Typography>
                  </Skeleton>
                }
                secondary={
                  <Grid flexWrap={isTabletOrMobile ? 'wrap' : 'nowrap'} justifyContent="flex-start" alignItems="center" container>
                    {isDesktop && (
                      <>
                        <LateFeeStatItem
                          primary={
                            <Skeleton>
                              <Box width={150} height="1rem" />
                            </Skeleton>
                          }
                          secondary={
                            <Skeleton>
                              <Box width={150} height="1rem" />
                            </Skeleton>
                          }
                          divider
                          lg={2}
                          xl={1}
                          ListItemSx={{
                            pl: 0,
                          }}
                          sx={{
                            minWidth: {
                              lg: '100px',
                              xl: '150px',
                            },
                          }}
                        />
                        <LateFeeStatItem
                          primary={
                            <Skeleton>
                              <Box width={150} height="1rem" />
                            </Skeleton>
                          }
                          secondary={
                            <Skeleton>
                              <Box width={150} height="1rem" />
                            </Skeleton>
                          }
                          divider
                          lg={2}
                          xl={1}
                          ListItemSx={{
                            pl: 1,
                          }}
                          sx={{
                            minWidth: {
                              lg: '100px',
                              xl: '150px',
                            },
                          }}
                        />
                        <LateFeeStatItem
                          primary={
                            <Skeleton>
                              <Box width={150} height="1rem" />
                            </Skeleton>
                          }
                          secondary={
                            <Skeleton>
                              <Box width={150} height="1rem" />
                            </Skeleton>
                          }
                          divider={isXs || isDesktop}
                          lg={2}
                          xl={1}
                          ListItemSx={{
                            pl: 1,
                          }}
                          sx={{
                            minWidth: {
                              lg: '100px',
                              xl: '150px',
                            },
                          }}
                        />
                        <LateFeeStatItem
                          lg={2}
                          xl={1}
                          sx={{
                            minWidth: {
                              lg: '100px',
                              xl: '150px',
                            },
                          }}
                          ListItemSx={{
                            pl: 1,
                          }}
                          primary={
                            <Skeleton>
                              <Box width={150} height="1rem" />
                            </Skeleton>
                          }
                          secondary={
                            <Skeleton>
                              <Box width={150} height="1rem" />
                            </Skeleton>
                          }
                          divider
                        />
                        <LateFeeStatItem
                          lg={4}
                          primary={
                            <Skeleton>
                              <Box width={150} height="1rem" />
                            </Skeleton>
                          }
                          secondary={
                            <Skeleton>
                              <Box width={150} height="1rem" />
                            </Skeleton>
                          }
                          xl={8}
                          ListItemSx={{
                            pl: 1,
                          }}
                          sx={{
                            maxWidth: {
                              lg: 'unset',
                              xl: 'unset',
                            },
                          }}
                        />
                      </>
                    )}
                    {isTablet && (
                      <>
                        <Grid container size={12}>
                          <LateFeeStatItem
                            sm
                            md
                            primary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            secondary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            divider
                          />
                          <LateFeeStatItem
                            sm
                            md
                            primary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            secondary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            divider
                          />
                          <LateFeeStatItem
                            sm
                            md
                            rimary={<Box width={150} height="1rem" />}
                            secondary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                          />
                        </Grid>
                        <Grid container flexWrap="nowrap" size={12}>
                          <LateFeeStatItem
                            sm={4}
                            md={4}
                            primary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            secondary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            divider
                          />
                          <LateFeeStatItem
                            md
                            primary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            secondary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            sm
                            sx={{
                              maxWidth: {
                                md: 'unset',
                              },
                            }}
                          />
                        </Grid>
                      </>
                    )}
                    {isMobile && (
                      <>
                        <Grid container size={12}>
                          <LateFeeStatItem
                            xs={12}
                            sm
                            md
                            primary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            secondary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            divider
                          />
                          <LateFeeStatItem
                            divider={isXs}
                            md
                            primary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            secondary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            sm
                            xs={12}
                          />
                        </Grid>
                        <Grid container size={12}>
                          <LateFeeStatItem
                            divider
                            md
                            primary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            secondary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            sm
                            xs={12}
                          />
                          <LateFeeStatItem
                            xs={12}
                            sm
                            md
                            primary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            secondary={
                              <Skeleton>
                                <Box width={150} height="1rem" />
                              </Skeleton>
                            }
                            divider={isXs}
                          />
                        </Grid>
                        <LateFeeStatItem
                          rimary={<Box width={150} height="1rem" />}
                          secondary={
                            <Skeleton>
                              <Box width={150} height="1rem" />
                            </Skeleton>
                          }
                          xs={12}
                          sx={{
                            maxWidth: {
                              sm: 'unset',
                            },
                          }}
                        />
                      </>
                    )}
                  </Grid>
                }
              />
            </ListItem>
          </Grid>
          <Grid
            sx={{
              minWidth: {
                xs: '12rem',
                sm: '12rem',
                md: '12rem',
                lg: '13rem',
                xl: '24rem',
              },
            }}
          >
            <Grid container flexWrap="nowrap" alignItems="center" justifyContent="flex-end" columnGap={2}>
              <Grid>
                <Skeleton variant="circular" width={24} height={24} />
              </Grid>
              <Grid />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </ListItem>
  )
}

LateFeesAccordionItemSkeleton.propTypes = {}

export default LateFeesAccordionItemSkeleton
